import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface Abilities {
  loading: boolean;
  data: [];
  status: number;
  // error:null| string
}

export const initialState: Abilities = {
  loading: false,
  data: [],
  status: 0,
  // error:null
};

const abilitiesListSlice = createSlice({
  name: "abilitiesList",
  initialState,
  reducers: {
    reset: () => initialState,
    abilitiesListRequest(state: Abilities, action: PayloadAction<any>) {
      state.loading = true;
    },
    abilitiesListSuccess(
      state: Abilities,
      action: PayloadAction<{ data: any; status: number }>,
    ) {
      state.loading = false;
      state.data = action.payload.data;
      state.status = action.payload.status;
    },
    abilitiesListFailure(state: Abilities) {
      state.loading = false;
      // state.error = action.payload;
    },
  },
});

export const abilitiesListAction = abilitiesListSlice.actions;
export const abilitiesListReducer = abilitiesListSlice.reducer;

export default abilitiesListReducer;
